<template>
  <v-menu v-model="menu" ref="menu" :close-on-content-click="false"
          :return-value="localValue" min-width="290"
          transition="scale-transition" offset-y>
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="localValue"
        :prepend-icon="timeIcon"
        :disabled="disabled || !isActive"
        :placeholder="placeholder"
        :persistent-hint="hint"
        :hint="$vuetify.lang.t(hintText)"
        readonly
        clearable
        dense
        :clear-icon="closeIcon"
        class="pa-2"
        v-on="on"
      ></v-text-field>
    </template>
    <v-time-picker v-if="menu" v-model="localValue" color="purple" @click:minute="$refs.menu.save(localValue)"
                   format="24hr">
    </v-time-picker>
  </v-menu>
</template>

<script>
import { mdiAlarm, mdiClose } from '@mdi/js'

export default {
  name: 'timeFilter',
  data: () => ({
    menu: false,
    localValue: null,

    timeIcon: mdiAlarm,
    closeIcon: mdiClose
  }),
  props: {
    type: String,
    disabled: Boolean,
    hint: {
      type: Boolean,
      default: false
    },
    hintText: {
      type: String,
      default: ''
    },
    isActive: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    placeholder () {
      return this.type === 'start' ? '00:00' : '23:59'
    }
  },
  methods: {
    clearState () {
      this.localValue = ''
      this.menu = false
    },
    setState (value) {
      this.localValue = value
    }
  },
  watch: {
    localValue (value) {
      this.$emit('time-filter-changed', { value: this.localValue, type: this.type })
    }
  }
}
</script>

<style scoped>

</style>
